import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePreferences } from '../contexts/PreferenceContext';
import referenceService from '../services/referenceService';
import logger from '../utils/logger';

function LanguageSelector({ onLanguageChange }) {
  const { t, i18n } = useTranslation();
  const { updatePreference } = usePreferences();
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load languages from database on component mount
  useEffect(() => {
    const loadLanguages = async () => {
      try {
        setLoading(true);
        const languageData = await referenceService.getLanguages();
        setLanguages(languageData);
      } catch (error) {
        logger.error('Failed to load languages', error);
        // Keep loading state if database fails - show error to user
        setLanguages([]);
      } finally {
        setLoading(false);
      }
    };

    loadLanguages();
  }, []);

  const changeLanguage = async (event) => {
    const language = event.target.value;
    try {
      // Context owns persistence and i18n publication. Closing the mobile
      // control only after true keeps a failed selection visible for retry.
      const acknowledged = await updatePreference('language', language);
      if (acknowledged && onLanguageChange) {
        onLanguageChange(); // Call the callback function to close the mobile menu
      }
    } catch (error) {
      logger.warn('Failed to update language preference', error);
    }
  };

  if (loading) {
    return (
      <select disabled>
        <option>{t('Loading...')}</option>
      </select>
    );
  }

  if (languages.length === 0) {
    return (
      <select disabled>
        <option>{t('Error loading languages')}</option>
      </select>
    );
  }

  return (
    <select onChange={changeLanguage} value={i18n.language}>
      {languages.map((language) => (
        <option key={language.language_code} value={language.language_code}>
          {language.language_name}
        </option>
      ))}
    </select>
  );
}

export default LanguageSelector;
